import { defineMessages } from 'react-intl';

const colorPickerSchema = ({ data, intl }) => {
  const colorPickerSchema = [
    {
      name: 'primary',
      label: intl.formatMessage(messages.primary),
    },
    {
      name: 'secondary',
      label: intl.formatMessage(messages.secondary),
    },
    {
      name: 'bookingWidgetColorRed',
      label: intl.formatMessage(messages.bookingWidgetColorRed),
    },
    {
      name: 'bookingWidgetColorBlue',
      label: intl.formatMessage(messages.bookingWidgetColorBlue),
    },
    {
      name: 'bookingWidgetColorSalmon',
      label: intl.formatMessage(messages.bookingWidgetColorSalmon),
    },
  ];

  return colorPickerSchema;
};

const prenotazioniSchema = ({ data, intl }) => {
  const schema = {
    title: intl.formatMessage(messages.prenotazioni_title),
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['tabColor1', 'tabColor2', 'tabColor3'],
      },
    ],
    properties: {
      tabColor1: {
        title: intl.formatMessage(messages.prenotazioni_tabColor1),
        widget: 'color_picker',
        colors: colorPickerSchema({ intl }),
      },
      tabColor2: {
        title: intl.formatMessage(messages.prenotazioni_tabColor2),
        widget: 'color_picker',
        colors: colorPickerSchema({ intl }),
      },
      tabColor3: {
        title: intl.formatMessage(messages.prenotazioni_tabColor3),
        widget: 'color_picker',
        colors: colorPickerSchema({ intl }),
      },
    },
    required: [],
  };

  return schema;
};

export default prenotazioniSchema;

const messages = defineMessages({
  prenotazioni_title: {
    id: 'prenotazioni_title',
    defaultMessage: 'Prenotazioni',
  },
  prenotazioni_tabColor1: {
    id: 'prenotazioni_tabColor1',
    defaultMessage: 'Colore "Dove dormire"',
  },
  prenotazioni_tabColor2: {
    id: 'prenotazioni_tabColor2',
    defaultMessage: 'Colore "Esperienze"',
  },
  prenotazioni_tabColor3: {
    id: 'prenotazioni_tabColor3',
    defaultMessage: 'Colore "My Fe Card"',
  },
  primary: {
    id: 'primary',
    defaultMessage: 'Primario',
  },
  secondary: {
    id: 'secondary',
    defaultMessage: 'Secondario',
  },
  bookingWidgetColorRed: {
    id: 'bookingWidgetColorRed',
    defaultMessage: 'Rosso',
  },
  bookingWidgetColorBlue: {
    id: 'bookingWidgetColorBlue',
    defaultMessage: 'Azzurro',
  },
  bookingWidgetColorSalmon: {
    id: 'bookingWidgetColorSalmon',
    defaultMessage: 'Salmone',
  },
});
